<template>
  <div class="login-page">
    <!--Sending state-->
    <loading :active.sync="isSending"
    :can-cancel="false" 
    :is-full-page="true">
    </loading>
    <!--./Sending state-->
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form>
                <card type="login">
                  <h3 slot="header" class="header text-center">Inicio de sesión</h3>
                  <fg-input v-model="form.username" 
                            addon-left-icon="nc-icon nc-single-02"
                            placeholder="Nombre de usuario"
                            name="usuario"
                            autocomplete="off"
                            v-validate="modelValidations.username"
                            :error="getError('usuario')"></fg-input>
                  <fg-input v-model="form.password" 
                            addon-left-icon="nc-icon nc-key-25" 
                            placeholder="Contraseña"
                            name="contraseña"
                            autocomplete="off"
                            v-validate="modelValidations.password"
                            :error="getError('contraseña')"
                            type="password"></fg-input>
                  <router-link to="/password_change">¿Olvidó su contraseña?</router-link>
                  <br>
                  <p-button native-type="submit" @click.prevent="validate" slot="footer" type="warning" round block class="mb-3">Iniciar sesión</p-button>
                  
                </card>
              </form>
            </div>
          </div>
        </div>
        <div class="full-page-background" v-bind:style="loginBackground()"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import { Card, Checkbox, Button } from 'src/components/UIComponents';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import SecureLS from 'secure-ls'
  import { TOKEN_AUTH } from 'src/api/graphql/mutations/auth/TokenAuth';
  import axios from 'axios'
  export default {
    components: {
      Card,
      Loading,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
    methods: {
      loginBackground(){
        return 'background-image: url('+process.env.VUE_APP_BASE_ROUTE+'img/login_background.jpg)';
      },
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      /*** 
      * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
      */
      onSuccess(message){
          swal({
              title: `¡Correcto!`,
              text: message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'success'
          });
      },
      /*** 
      * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
      */
      onError(message){
          swal({
              title: `¡Alerta!`,
              text: message,
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger btn-fill',
              type: 'error'
          });
      },
      /*** 
      * Función que permite visualizar los errores en cada campo del input
      */
      getError (fieldName) {
          return this.errors.first(fieldName)
      },
      /***
      * Función para validar el formulario de edición y creación que se envía
      */
      validate () {
          this.$validator.validateAll().then(isValid => {
            if(isValid){
              // Iniciamos el envío de la mutación
              var vm = this;
              vm.isSending = true;
              this.$apollo.mutate({
                mutation: TOKEN_AUTH,
                variables : {
                    input : {
                      username: vm.form.username,
                      password: vm.form.password
                    }
                  }
              }).then((data) => {
                this.$store.dispatch('updateLoggingIn',data.data.tokenAuth).then(()=>{
                  vm.isSending = false;
                  this.$router.push('/');
                });
              }).catch((error) => {
                vm.isSending = false;
                if(error.graphQLErrors.length > 0)
                {
                  if (error.graphQLErrors[0].message == "There is already a session started with these credentials.") {
                    vm.onError("Ya hay una sesión iniciada para este usuario, cierra esa sesión o contacta al administrador");
                  }
                  else if(error.graphQLErrors[0].message == "Please, enter valid credentials") {
                    vm.onError("Las credenciales son incorrectas");
                  }
                  else {
                    vm.onError(error.graphQLErrors[0].message);
                  }
                  
                }
                else if (error.networkError) {
                
                switch (error.networkError.statusCode) {
                    case 500:
                      vm.onError("Ha ocurrido un error en el servidor, contacte con el administrador del sistema");
                      break
                    case 403:
                      if (error.networkError.bodyText == 'Cuenta bloqueada: demasiados intentos de inicio de sesión. Por favor, inténtelo de nuevo más tarde') {
                        vm.onError(error.networkError.bodyText);  
                      }
                      else {
                        vm.onError("La verificación de CSRF ha fallado. Recarga la página e intenta de nuevo");
                      }
                      break
                    case undefined:
                      vm.onError("Ha ocurrido un error en el servidor, contacte con el administrador del sistema");
                      break
                    default:
                      vm.onError("Ha ocurrido un error en el servidor, contacte con el administrador del sistema");
                      break
                  }
                }
                else
                {
                  vm.onError('Las credenciales son incorrectas');
                }
              });
            }
          })
      }
    },
    data() {
      return {
        isSending: false,
        fullPage: false,
        form: {
          username: '',
          password: ''
        },
        modelValidations: {
          username: {
              alpha_dash: true,
              required: true,
              max: 32
          },
          password: {
              required: true,
              max: 32
          },
        },
      }
    },
    mounted(){
    },
    beforeDestroy() {
      this.closeMenu();
    }
  }
</script>
<style>
</style>
